import type { User } from '@/api/users/types';

export const mockData: User[] = [
  {
    id: '',
    email: '',
    publicId: '550e8400-e29b-41d4-a716-446655440037',
    projectId: 'c4da99bb-893a-4647-bc35-9f7158b7607e',
    createdAt: '2024-01-01 15:30:00',
    voteCount: 15,
    requestCount: 3,
    userMeta: null,
    status: 'active',
    note: 'This is a note',
  },
  {
    id: '',
    email: '',
    publicId: '550e8400-e29b-41d4-a716-446655440018',
    projectId: 'c4da99bb-893a-4647-bc35-9f7158b7607e',
    createdAt: '2024-02-02 15:30:00',
    voteCount: 31,
    requestCount: 1,
    userMeta: null,
    status: 'active',
    note: 'This is a note',
  },
  {
    id: '',
    email: '',
    publicId: '550e8400-e29b-41d4-a716-44665544001b',
    projectId: 'c4da99bb-893a-4647-bc35-9f7158b7607e',
    createdAt: '2024-03-03 15:30:00',
    voteCount: 12,
    requestCount: 8,
    userMeta: null,
    status: 'active',
    note: 'This is a note',
  },
  {
    id: '',
    email: '',
    publicId: '550e8400-e29b-41d4-a716-446655440020',
    projectId: 'c4da99bb-893a-4647-bc35-9f7158b7607e',
    createdAt: '2024-04-04 15:30:00',
    voteCount: 58,
    requestCount: 0,
    userMeta: null,
    status: 'active',
    note: 'This is a note',
  },
];
